export default (node) => {
  /**
   * Data + elements
   */
  const swiperContainer = node.querySelector('.swiper-container');

  /**
   * Functions
   */
  const initSwiper = () => {
    new Swiper(swiperContainer, {
      spaceBetween: 20,
      grabCursor: true,
      breakpoints: {
        0: {
          slidesPerView: 1,
        },
        768: {
          slidesPerView: 4,
        },
      },
    });
  };
  /**
   * Init
   */
  const init = () => {
    if (swiperContainer) initSwiper();
  };

  init();
};
